/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

"use strict";

(function ($, window, document, undefined) {
    $(".ginput_container_fileupload").each(function () {
        // Create placeholder button
        $(this)
            .find('input[type="file"]')
            .before(
                '<button class="ghost theme-blue" type="button" aria-hidden="true">Select file</button>'
            );
    });

    $(".ginput_container_fileupload").on("click", "button", function () {
        var label = $(this).parent().parent().find("label");

        // Trigger file modal when clicking button
        label.trigger("click");
    });

    $(".ginput_container_fileupload")
        .find('input[type="file"]')
        .each(function () {
            var $input = $(this),
                $button = $input.prev("button"),
                labelVal = $button.text();

            $input.on("change", function (e) {
                var fileName = "";

                if (this.files && this.files.length > 1) {
                    fileName = (
                        this.getAttribute("data-multiple-caption") || ""
                    ).replace("{count}", this.files.length);
                } else if (e.target.value) {
                    fileName = e.target.value.split("\\").pop();
                }

                console.log($button);

                if (fileName) {
                    $button.text(fileName);
                } else {
                    $button.text(labelVal);
                }
            });

            // Firefox bug fix
            $input
                .on("focus", function () {
                    $input.addClass("has-focus");
                })
                .on("blur", function () {
                    $input.removeClass("has-focus");
                });
        });
})(jQuery, window, document);
